var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_8232_1699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.3333 6.66797V12.0013C21.3333 12.3549 21.4738 12.6941 21.7238 12.9441C21.9739 13.1942 22.313 13.3346 22.6666 13.3346H28",
    stroke: "#BEBEBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 9.33464V22.668C4 23.3752 4.28095 24.0535 4.78105 24.5536C5.28115 25.0537 5.95942 25.3346 6.66667 25.3346H25.3333C26.0406 25.3346 26.7189 25.0537 27.219 24.5536C27.719 24.0535 28 23.3752 28 22.668V13.3346L21.3333 6.66797H6.66667C5.95942 6.66797 5.28115 6.94892 4.78105 7.44902C4.28095 7.94911 4 8.62739 4 9.33464Z",
    stroke: "#BEBEBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8232_1699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPdf);
export default __webpack_public_path__ + "static/media/ic-pdf.c99bc7997a85aeac6c3de245139f963e.svg";
export { ForwardRef as ReactComponent };